import { useToastError } from 'lib/hooks';
import { useQuery } from 'react-query';
import { EXPRESS_API } from 'configs/api/expressApi';
import { optoutsKeys } from './optoutsKeys';

export interface IOptOutsResponse {
  count: number;
  optOutContacts: OptOutContact[];
}

export interface OptOutContact {
  phone2: string;
  fax: string;
  notes: string;
  dateOpted: Date;
  contactId: number;
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  companyName: string;
  url: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  type: Type;
}

export enum Type {
  Contact = 'Contact',
  Empty = '',
}

export type GetOptOutsParams = {
  start: number;
  limit: number;
  search?: string;
};

export const getOptOuts = async (
  params: GetOptOutsParams
): Promise<IOptOutsResponse> => {
  const { data } = await EXPRESS_API.get('/opt-outs', { params });

  return data;
};

export const useQueryOptOuts = (params: GetOptOutsParams) => {
  const { showError } = useToastError();
  return useQuery(optoutsKeys.optouts(params), () => getOptOuts(params), {
    onError: showError,
    refetchOnMount: true,
  });
};
